import * as Sentry from "@sentry/react";

const dsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
export const sentryEnabled = Boolean(dsn);

if (sentryEnabled) {
  const rate = Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1");
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number.isFinite(rate) ? Math.min(1, Math.max(0, rate)) : 0.1,
    tracePropagationTargets: [/^\//, new RegExp(`^${(process.env.REACT_APP_BACKEND_URL || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}/api`)],
    sendDefaultPii: false,
  });
}
